import moment from 'moment';
import React from 'react';
import { Redirect, useLocation } from 'react-router';

import { ServiceRangeUnavailable } from 'src/app/graph/errors/serviceRangeUnavailable/ServiceRangeUnavailable';
import {
  TimeRangeErrorCode,
  TimeRangeInfo,
  useSelectedTimeRange,
} from 'src/hooks/useSelectedTimeRange';
import Config from 'src/lib/config';
import { mergeQueryParams } from 'src/lib/routing';

// For backwards compatibility
export type { TimeRangeInfo };

type Props = {
  serviceId: string;
  children: (
    props: TimeRangeInfo & {
      loading: boolean;
      queryParams: { [queryParamName: string]: string };
    },
  ) => React.ReactElement;
};

/**
 * @deprecated use useSelectedTimeRange hook instead
 */
export const TimeRangeProvider = ({ children }: Props) => {
  const location = useLocation();
  const { timeRangeInfo, loading, error } = useSelectedTimeRange();
  if (loading) {
    return null;
  }
  if (error || !timeRangeInfo) {
    if (error?.code === TimeRangeErrorCode.INVALID) {
      return (
        <Redirect
          to={{
            ...location,
            search: mergeQueryParams(location.search, {
              [Config.queryParameters.SelectedTimeRange]: undefined,
              [Config.queryParameters.SelectedTimeRangeFrom]: undefined,
              [Config.queryParameters.SelectedTimeRangeTo]: undefined,
              [Config.queryParameters.FastModeRange]: undefined,
            }),
          }}
        />
      );
    }
    return <ServiceRangeUnavailable />;
  }
  const { accountCapabilities, selectedRange, timeFrom, timeTo } =
    timeRangeInfo;

  return children({
    accountCapabilities,
    selectedRange,
    timeFrom,
    timeTo,
    loading,
    queryParams: {
      [Config.queryParameters.SelectedTimeRange]: selectedRange,
      ...(selectedRange === 'custom' && timeFrom && timeTo
        ? {
            [Config.queryParameters.SelectedTimeRangeFrom]:
              moment(timeFrom).toISOString(),
            [Config.queryParameters.SelectedTimeRangeTo]:
              moment(timeTo).toISOString(),
          }
        : null),
    },
  });
};
